
export enum IconVariant {
    Active = "active",
    Disabled = "disabled",
}